// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════
   RATINGS & FEEDBACK  —  append to Orders.css
══════════════════════════════════════════════════════════════ */

/* ── Rate & Review button ── */
.leave-feedback-btn {
  background: #fff;
  border: 1.5px solid #e8590c;
  padding: 7px 14px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 600;
  color: #e8590c;
  transition: background 0.15s, box-shadow 0.15s, transform 0.12s;
  white-space: nowrap;
}
.leave-feedback-btn:hover {
  background: #fff4ef;
  box-shadow: 0 2px 8px rgba(232,89,12,0.2);
  transform: translateY(-1px);
}
.leave-feedback-btn.reviewed {
  background: #fff8e1;
  border-color: #f9a825;
  color: #e65100;
}

/* ── Order item layout ── */
.order-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
  transition: background 0.15s;
}
.order-item:last-child { border-bottom: none; }
.order-item:hover { background: #fafbfc; }
.order-item-actions {
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  padding-top: 2px;
}

/* ── Review badge ── */
.review-submitted-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 5px 10px;
  background: linear-gradient(90deg, #fff8e1, #fff3cd);
  border: 1px solid #ffe082;
  border-radius: 4px;
  flex-wrap: wrap;
}
.review-feedback-preview {
  font-size: 12px;
  color: #6d4c14;
  font-style: italic;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Star display read-only ── */
.star-display { display: inline-flex; align-items: center; gap: 1px; }
.star-display .star-filled { color: #ff9800; font-size: 13px; }
.star-display .star-empty  { color: #ddd;    font-size: 13px; }
.star-display-value {
  margin-left: 5px; font-size: 12px; font-weight: 700;
  color: #388e3c; background: #e8f5e9; border: 1px solid #a5d6a7;
  border-radius: 3px; padding: 1px 5px;
}

/* ── Merchant strip ── */
.merchant-rating-summary {
  display: flex; align-items: center; flex-wrap: wrap; gap: 10px;
  padding: 9px 20px;
  background: linear-gradient(90deg, #fff8e1, #fffde7);
  border-top: 1px solid #ffe082; border-bottom: 1px solid #ffe082;
}
.rating-count-text {
  font-size: 12px; font-weight: 600; color: #795548;
  background: rgba(255,255,255,0.7); border-radius: 3px; padding: 2px 7px;
}
.merchant-latest-feedback {
  font-size: 12px; color: #5d4037; font-style: italic;
  max-width: 320px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

/* ══════════════════════════════════════════════════════════════
   RATING MODAL
══════════════════════════════════════════════════════════════ */

/* Overlay — reuse popup-overlay but the modal itself is standalone */
.rating-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.15s ease;
}

.rating-modal {
  position: relative;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 16px 56px rgba(0,0,0,0.28);
  max-width: 400px;
  width: 92%;
  overflow: hidden;
  animation: ratingModalIn 0.26s cubic-bezier(0.34,1.4,0.64,1) both;
}

@keyframes ratingModalIn {
  from { opacity: 0; transform: translateY(36px) scale(0.94); }
  to   { opacity: 1; transform: translateY(0)    scale(1);    }
}

/* ── Orange header ── */
.rating-modal-header {
  background: linear-gradient(120deg, #f4511e 0%, #ff7043 55%, #ffa726 100%);
  padding: 14px 16px 14px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
}

.rating-modal-close {
  position: absolute !important;
  top: 10px !important;
  right: 12px !important;
  background: rgba(255,255,255,0.25) !important;
  border: none !important;
  color: #fff !important;
  font-size: 20px !important;
  width: 28px !important;
  height: 28px !important;
  min-width: unset !important;
  border-radius: 50% !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
  padding: 0 !important;
  transition: background 0.15s !important;
  box-shadow: none !important;
  font-weight: 300 !important;
}
.rating-modal-close:hover { background: rgba(255,255,255,0.4) !important; transform: none !important; }

.rating-modal-img {
  width: 54px !important;
  height: 54px !important;
  min-width: 54px !important;
  object-fit: cover !important;
  border-radius: 8px !important;
  border: 2px solid rgba(255,255,255,0.5) !important;
  flex-shrink: 0 !important;
  display: block !important;
}

.rating-modal-name {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  line-height: 1.35;
  text-shadow: 0 1px 4px rgba(0,0,0,0.2);
  padding-right: 36px; /* space for close btn */
}

/* ── Body ── */
.rating-modal-body {
  padding: 20px 22px 18px;
  text-align: center;
}

.rating-modal-title {
  font-size: 16px; font-weight: 700; color: #212121; margin: 0 0 3px;
}
.rating-modal-subtitle {
  font-size: 12px; color: #9e9e9e; margin: 0 0 16px;
}

/* ── Star picker — reset ALL inherited button styles ── */
.star-picker {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-bottom: 4px;
}

.star-picker .star-btn {
  /* Hard reset — fights any global button styles */
  all: unset;
  cursor: pointer;
  font-size: 38px;
  color: #e0e0e0;
  display: flex;
  align-items: center;
  padding: 0 3px;
  line-height: 1;
  transition: color 0.1s, transform 0.14s cubic-bezier(0.34,1.6,0.64,1);
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}
.star-picker .star-btn.filled {
  color: #ff9800;
  filter: drop-shadow(0 2px 5px rgba(255,152,0,0.5));
  transform: scale(1.1);
}
.star-picker .star-btn:hover {
  transform: scale(1.3);
  color: #ffb300;
  background: transparent !important;
}

.star-label {
  font-size: 12.5px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.5px; color: #e65100; min-height: 20px; margin-bottom: 12px;
}

/* ── Chips ── */
.feedback-tags {
  display: flex; flex-wrap: wrap; gap: 7px;
  justify-content: center; margin-bottom: 14px;
}
.feedback-tag {
  all: unset;
  padding: 5px 13px;
  border-radius: 100px;
  border: 1.5px solid #e0e0e0;
  background: #fafafa !important;
  font-size: 12px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  color: #616161 !important;
  cursor: pointer;
  transition: all 0.15s;
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  box-sizing: border-box;
}
.feedback-tag:hover  { border-color: #ff7043 !important; background: #fff4ef !important; color: #e64a19 !important; }
.feedback-tag.selected {
  border-color: #f4511e !important;
  background: #fff3ee !important;
  color: #bf360c !important;
  font-weight: 600;
}

/* ── Divider ── */
.rating-divider {
  display: flex; align-items: center; gap: 10px;
  margin: 10px 0 12px; color: #bdbdbd;
  font-size: 11px; font-weight: 600; letter-spacing: 0.8px; text-transform: uppercase;
}
.rating-divider::before,
.rating-divider::after { content: ''; flex: 1 1; height: 1px; background: #eeeeee; }

/* ── Textarea ── */
.feedback-textarea {
  width: 100%; padding: 10px 13px;
  border: 1.5px solid #e0e0e0; border-radius: 6px;
  font-family: 'DM Sans', sans-serif; font-size: 13.5px;
  color: #212121; background: #fafafa; resize: none;
  box-sizing: border-box; line-height: 1.5;
  transition: border-color 0.18s, box-shadow 0.18s;
}
.feedback-textarea:focus {
  outline: none; border-color: #f4511e;
  background: #fff; box-shadow: 0 0 0 3px rgba(244,81,30,0.1);
}
.feedback-textarea::placeholder { color: #bdbdbd; }
.feedback-charcount { text-align: right; font-size: 11px; color: #bdbdbd; margin-top: 3px; }

/* ── Error ── */
.rating-error {
  display: flex; align-items: center; gap: 6px;
  background: #fff3f3; color: #c62828;
  border: 1px solid #ffcdd2; border-left: 3px solid #e53935;
  border-radius: 5px; padding: 8px 12px;
  font-size: 12.5px; font-weight: 500; margin-top: 10px; text-align: left;
  animation: shakeX 0.3s ease;
}
@keyframes shakeX {
  0%,100% { transform: translateX(0);   }
  25%      { transform: translateX(-5px); }
  75%      { transform: translateX(5px);  }
}

/* ── Action buttons ── */
.rating-modal-actions { display: flex; gap: 10px; margin-top: 16px; }

.rating-submit-btn {
  all: unset;
  flex: 1 1;
  background: linear-gradient(135deg, #f4511e 0%, #ff7043 100%);
  color: #fff;
  padding: 12px 20px;
  border-radius: 6px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px; font-weight: 700; letter-spacing: 0.3px;
  cursor: pointer; text-align: center; box-sizing: border-box;
  box-shadow: 0 3px 14px rgba(244,81,30,0.38);
  transition: all 0.18s;
  display: block;
}
.rating-submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #d84315, #e64a19);
  box-shadow: 0 5px 20px rgba(244,81,30,0.48);
  transform: translateY(-1px);
}
.rating-submit-btn:active:not(:disabled) { transform: scale(0.98); }

.rating-cancel-btn {
  all: unset;
  background: #f5f5f5;
  color: #616161;
  border: 1px solid #e0e0e0;
  padding: 12px 20px;
  border-radius: 6px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px; font-weight: 600;
  cursor: pointer; text-align: center; box-sizing: border-box;
  transition: all 0.15s;
  display: block;
}
.rating-cancel-btn:hover { background: #eeeeee; color: #212121; }

.rating-submit-btn:disabled,
.rating-cancel-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Responsive ── */
@media (max-width: 600px) {
  .order-item { flex-wrap: wrap; }
  .order-item-actions { margin-left: 0; width: 100%; align-items: flex-start; flex-direction: row; }
  .star-picker .star-btn { font-size: 32px; }
  .rating-modal-body { padding: 16px; }
}`, "",{"version":3,"sources":["webpack://./src/components/Ratings.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAEhE,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,+DAA+D;EAC/D,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;AAC9B;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,oBAAoB,mBAAmB,EAAE;AACzC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,oDAAoD;EACpD,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACrE,6BAA6B,cAAc,EAAE,eAAe,EAAE;AAC9D,6BAA6B,WAAW,KAAK,eAAe,EAAE;AAC9D;EACE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB;EACnD,cAAc,EAAE,mBAAmB,EAAE,yBAAyB;EAC9D,kBAAkB,EAAE,gBAAgB;AACtC;;AAEA,yBAAyB;AACzB;EACE,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,SAAS;EAC9D,iBAAiB;EACjB,oDAAoD;EACpD,6BAA6B,EAAE,gCAAgC;AACjE;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjD,iCAAiC,EAAE,kBAAkB,EAAE,gBAAgB;AACzE;AACA;EACE,eAAe,EAAE,cAAc,EAAE,kBAAkB;EACnD,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAClF;;AAEA;;gEAEgE;;AAEhE,qEAAqE;AACrE;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,iEAAiE;AACnE;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,oCAAoC,KAAK;AAC9D;;AAEA,wBAAwB;AACxB;EACE,0EAA0E;EAC1E,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,6CAA6C;EAC7C,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA,4BAA4B,4CAA4C,EAAE,0BAA0B,EAAE;;AAEtG;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,kDAAkD;EAClD,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB,EAAE,wBAAwB;AAC/C;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe;AACpE;AACA;EACE,eAAe,EAAE,cAAc,EAAE,gBAAgB;AACnD;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,UAAU;EACV,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,qEAAqE;EACrE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,kDAAkD;EAClD,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,iBAAiB,EAAE,gBAAgB,EAAE,yBAAyB;EAC9D,qBAAqB,EAAE,cAAc,EAAE,gBAAgB,EAAE,mBAAmB;AAC9E;;AAEA,gBAAgB;AAChB;EACE,aAAa,EAAE,eAAe,EAAE,QAAQ;EACxC,uBAAuB,EAAE,mBAAmB;AAC9C;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA,uBAAuB,gCAAgC,EAAE,8BAA8B,EAAE,yBAAyB,EAAE;AACpH;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,mBAAmB,EAAE,cAAc;EACnC,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB;AACrF;AACA;yBACyB,WAAW,EAAE,SAAO,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAEjF,mBAAmB;AACnB;EACE,WAAW,EAAE,kBAAkB;EAC/B,2BAA2B,EAAE,kBAAkB;EAC/C,kCAAkC,EAAE,iBAAiB;EACrD,cAAc,EAAE,mBAAmB,EAAE,YAAY;EACjD,sBAAsB,EAAE,gBAAgB;EACxC,gDAAgD;AAClD;AACA;EACE,aAAa,EAAE,qBAAqB;EACpC,gBAAgB,EAAE,yCAAyC;AAC7D;AACA,kCAAkC,cAAc,EAAE;AAClD,sBAAsB,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAE3F,gBAAgB;AAChB;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,mBAAmB,EAAE,cAAc;EACnC,yBAAyB,EAAE,8BAA8B;EACzD,kBAAkB,EAAE,iBAAiB;EACrC,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB;EACvE,2BAA2B;AAC7B;AACA;EACE,UAAU,wBAAwB,IAAI;EACtC,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,GAAG;AAC1C;;AAEA,yBAAyB;AACzB,wBAAwB,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEpE;EACE,UAAU;EACV,SAAO;EACP,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe,EAAE,gBAAgB,EAAE,qBAAqB;EACxD,eAAe,EAAE,kBAAkB,EAAE,sBAAsB;EAC3D,2CAA2C;EAC3C,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qDAAqD;EACrD,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA,2CAA2C,sBAAsB,EAAE;;AAEnE;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe,EAAE,gBAAgB;EACjC,eAAe,EAAE,kBAAkB,EAAE,sBAAsB;EAC3D,qBAAqB;EACrB,cAAc;AAChB;AACA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE;8BAC8B,YAAY,EAAE,mBAAmB,EAAE;;AAEjE,qBAAqB;AACrB;EACE,cAAc,eAAe,EAAE;EAC/B,sBAAsB,cAAc,EAAE,WAAW,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;EACjG,yBAAyB,eAAe,EAAE;EAC1C,qBAAqB,aAAa,EAAE;AACtC","sourcesContent":["/* ══════════════════════════════════════════════════════════════\n   RATINGS & FEEDBACK  —  append to Orders.css\n══════════════════════════════════════════════════════════════ */\n\n/* ── Rate & Review button ── */\n.leave-feedback-btn {\n  background: #fff;\n  border: 1.5px solid #e8590c;\n  padding: 7px 14px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12.5px;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 600;\n  color: #e8590c;\n  transition: background 0.15s, box-shadow 0.15s, transform 0.12s;\n  white-space: nowrap;\n}\n.leave-feedback-btn:hover {\n  background: #fff4ef;\n  box-shadow: 0 2px 8px rgba(232,89,12,0.2);\n  transform: translateY(-1px);\n}\n.leave-feedback-btn.reviewed {\n  background: #fff8e1;\n  border-color: #f9a825;\n  color: #e65100;\n}\n\n/* ── Order item layout ── */\n.order-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border);\n  transition: background 0.15s;\n}\n.order-item:last-child { border-bottom: none; }\n.order-item:hover { background: #fafbfc; }\n.order-item-actions {\n  margin-left: auto;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  padding-top: 2px;\n}\n\n/* ── Review badge ── */\n.review-submitted-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n  padding: 5px 10px;\n  background: linear-gradient(90deg, #fff8e1, #fff3cd);\n  border: 1px solid #ffe082;\n  border-radius: 4px;\n  flex-wrap: wrap;\n}\n.review-feedback-preview {\n  font-size: 12px;\n  color: #6d4c14;\n  font-style: italic;\n  max-width: 240px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ── Star display read-only ── */\n.star-display { display: inline-flex; align-items: center; gap: 1px; }\n.star-display .star-filled { color: #ff9800; font-size: 13px; }\n.star-display .star-empty  { color: #ddd;    font-size: 13px; }\n.star-display-value {\n  margin-left: 5px; font-size: 12px; font-weight: 700;\n  color: #388e3c; background: #e8f5e9; border: 1px solid #a5d6a7;\n  border-radius: 3px; padding: 1px 5px;\n}\n\n/* ── Merchant strip ── */\n.merchant-rating-summary {\n  display: flex; align-items: center; flex-wrap: wrap; gap: 10px;\n  padding: 9px 20px;\n  background: linear-gradient(90deg, #fff8e1, #fffde7);\n  border-top: 1px solid #ffe082; border-bottom: 1px solid #ffe082;\n}\n.rating-count-text {\n  font-size: 12px; font-weight: 600; color: #795548;\n  background: rgba(255,255,255,0.7); border-radius: 3px; padding: 2px 7px;\n}\n.merchant-latest-feedback {\n  font-size: 12px; color: #5d4037; font-style: italic;\n  max-width: 320px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   RATING MODAL\n══════════════════════════════════════════════════════════════ */\n\n/* Overlay — reuse popup-overlay but the modal itself is standalone */\n.rating-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.55);\n  backdrop-filter: blur(4px);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.15s ease;\n}\n\n.rating-modal {\n  position: relative;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 16px 56px rgba(0,0,0,0.28);\n  max-width: 400px;\n  width: 92%;\n  overflow: hidden;\n  animation: ratingModalIn 0.26s cubic-bezier(0.34,1.4,0.64,1) both;\n}\n\n@keyframes ratingModalIn {\n  from { opacity: 0; transform: translateY(36px) scale(0.94); }\n  to   { opacity: 1; transform: translateY(0)    scale(1);    }\n}\n\n/* ── Orange header ── */\n.rating-modal-header {\n  background: linear-gradient(120deg, #f4511e 0%, #ff7043 55%, #ffa726 100%);\n  padding: 14px 16px 14px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.rating-modal-close {\n  position: absolute !important;\n  top: 10px !important;\n  right: 12px !important;\n  background: rgba(255,255,255,0.25) !important;\n  border: none !important;\n  color: #fff !important;\n  font-size: 20px !important;\n  width: 28px !important;\n  height: 28px !important;\n  min-width: unset !important;\n  border-radius: 50% !important;\n  cursor: pointer !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  line-height: 1 !important;\n  padding: 0 !important;\n  transition: background 0.15s !important;\n  box-shadow: none !important;\n  font-weight: 300 !important;\n}\n.rating-modal-close:hover { background: rgba(255,255,255,0.4) !important; transform: none !important; }\n\n.rating-modal-img {\n  width: 54px !important;\n  height: 54px !important;\n  min-width: 54px !important;\n  object-fit: cover !important;\n  border-radius: 8px !important;\n  border: 2px solid rgba(255,255,255,0.5) !important;\n  flex-shrink: 0 !important;\n  display: block !important;\n}\n\n.rating-modal-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.35;\n  text-shadow: 0 1px 4px rgba(0,0,0,0.2);\n  padding-right: 36px; /* space for close btn */\n}\n\n/* ── Body ── */\n.rating-modal-body {\n  padding: 20px 22px 18px;\n  text-align: center;\n}\n\n.rating-modal-title {\n  font-size: 16px; font-weight: 700; color: #212121; margin: 0 0 3px;\n}\n.rating-modal-subtitle {\n  font-size: 12px; color: #9e9e9e; margin: 0 0 16px;\n}\n\n/* ── Star picker — reset ALL inherited button styles ── */\n.star-picker {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n\n.star-picker .star-btn {\n  /* Hard reset — fights any global button styles */\n  all: unset;\n  cursor: pointer;\n  font-size: 38px;\n  color: #e0e0e0;\n  display: flex;\n  align-items: center;\n  padding: 0 3px;\n  line-height: 1;\n  transition: color 0.1s, transform 0.14s cubic-bezier(0.34,1.6,0.64,1);\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n}\n.star-picker .star-btn.filled {\n  color: #ff9800;\n  filter: drop-shadow(0 2px 5px rgba(255,152,0,0.5));\n  transform: scale(1.1);\n}\n.star-picker .star-btn:hover {\n  transform: scale(1.3);\n  color: #ffb300;\n  background: transparent !important;\n}\n\n.star-label {\n  font-size: 12.5px; font-weight: 700; text-transform: uppercase;\n  letter-spacing: 0.5px; color: #e65100; min-height: 20px; margin-bottom: 12px;\n}\n\n/* ── Chips ── */\n.feedback-tags {\n  display: flex; flex-wrap: wrap; gap: 7px;\n  justify-content: center; margin-bottom: 14px;\n}\n.feedback-tag {\n  all: unset;\n  padding: 5px 13px;\n  border-radius: 100px;\n  border: 1.5px solid #e0e0e0;\n  background: #fafafa !important;\n  font-size: 12px;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 500;\n  color: #616161 !important;\n  cursor: pointer;\n  transition: all 0.15s;\n  user-select: none;\n  display: inline-block;\n  box-sizing: border-box;\n}\n.feedback-tag:hover  { border-color: #ff7043 !important; background: #fff4ef !important; color: #e64a19 !important; }\n.feedback-tag.selected {\n  border-color: #f4511e !important;\n  background: #fff3ee !important;\n  color: #bf360c !important;\n  font-weight: 600;\n}\n\n/* ── Divider ── */\n.rating-divider {\n  display: flex; align-items: center; gap: 10px;\n  margin: 10px 0 12px; color: #bdbdbd;\n  font-size: 11px; font-weight: 600; letter-spacing: 0.8px; text-transform: uppercase;\n}\n.rating-divider::before,\n.rating-divider::after { content: ''; flex: 1; height: 1px; background: #eeeeee; }\n\n/* ── Textarea ── */\n.feedback-textarea {\n  width: 100%; padding: 10px 13px;\n  border: 1.5px solid #e0e0e0; border-radius: 6px;\n  font-family: 'DM Sans', sans-serif; font-size: 13.5px;\n  color: #212121; background: #fafafa; resize: none;\n  box-sizing: border-box; line-height: 1.5;\n  transition: border-color 0.18s, box-shadow 0.18s;\n}\n.feedback-textarea:focus {\n  outline: none; border-color: #f4511e;\n  background: #fff; box-shadow: 0 0 0 3px rgba(244,81,30,0.1);\n}\n.feedback-textarea::placeholder { color: #bdbdbd; }\n.feedback-charcount { text-align: right; font-size: 11px; color: #bdbdbd; margin-top: 3px; }\n\n/* ── Error ── */\n.rating-error {\n  display: flex; align-items: center; gap: 6px;\n  background: #fff3f3; color: #c62828;\n  border: 1px solid #ffcdd2; border-left: 3px solid #e53935;\n  border-radius: 5px; padding: 8px 12px;\n  font-size: 12.5px; font-weight: 500; margin-top: 10px; text-align: left;\n  animation: shakeX 0.3s ease;\n}\n@keyframes shakeX {\n  0%,100% { transform: translateX(0);   }\n  25%      { transform: translateX(-5px); }\n  75%      { transform: translateX(5px);  }\n}\n\n/* ── Action buttons ── */\n.rating-modal-actions { display: flex; gap: 10px; margin-top: 16px; }\n\n.rating-submit-btn {\n  all: unset;\n  flex: 1;\n  background: linear-gradient(135deg, #f4511e 0%, #ff7043 100%);\n  color: #fff;\n  padding: 12px 20px;\n  border-radius: 6px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px; font-weight: 700; letter-spacing: 0.3px;\n  cursor: pointer; text-align: center; box-sizing: border-box;\n  box-shadow: 0 3px 14px rgba(244,81,30,0.38);\n  transition: all 0.18s;\n  display: block;\n}\n.rating-submit-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #d84315, #e64a19);\n  box-shadow: 0 5px 20px rgba(244,81,30,0.48);\n  transform: translateY(-1px);\n}\n.rating-submit-btn:active:not(:disabled) { transform: scale(0.98); }\n\n.rating-cancel-btn {\n  all: unset;\n  background: #f5f5f5;\n  color: #616161;\n  border: 1px solid #e0e0e0;\n  padding: 12px 20px;\n  border-radius: 6px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px; font-weight: 600;\n  cursor: pointer; text-align: center; box-sizing: border-box;\n  transition: all 0.15s;\n  display: block;\n}\n.rating-cancel-btn:hover { background: #eeeeee; color: #212121; }\n\n.rating-submit-btn:disabled,\n.rating-cancel-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n  .order-item { flex-wrap: wrap; }\n  .order-item-actions { margin-left: 0; width: 100%; align-items: flex-start; flex-direction: row; }\n  .star-picker .star-btn { font-size: 32px; }\n  .rating-modal-body { padding: 16px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
